import React from "react";
import { Modal } from "react-bootstrap";

import { Fail } from "../../common/svg";
import dl_confirm from "../../../static/images/drive-license/dl-confirm.png";

export const VerifyPhoneDL = ({ show, onHide, openNotifLicense }) => {
	return (
		<Modal show={show} onHide={onHide} dialogClassName="modal-s modal-dialog modal-confirm">
			<Modal.Header closeButton={true} closeLabel={""}>
				<div className="wrap-svg">
					<Fail />
				</div>
			</Modal.Header>
			<Modal.Body>
				<div className="modal-confirm-body">
					<p className="font-14">
						Bạn cần xác thực <strong>GPLX</strong> và <strong>số điện thoại</strong> mới có thể đặt xe.
					</p>
					<a className="btn btn-primary btn--m" onClick={openNotifLicense}>
						Đồng ý
					</a>
				</div>
			</Modal.Body>
		</Modal>
	);
};

export const VerifyPhoneBox = ({ show, onHide, showChangePhone }) => {
	return (
		<Modal show={show} onHide={onHide} dialogClassName="modal-s modal-dialog modal-confirm">
			<Modal.Header closeButton={true} closeLabel={""}>
				<div className="wrap-svg">
					<Fail />
				</div>
			</Modal.Header>
			<Modal.Body>
				<div className="modal-confirm-body">
					<p className="font-14">Bạn cần xác minh số điện thoại mới có thể đặt xe.</p>
					<a className="btn btn-primary btn--m" onClick={showChangePhone}>
						Cập nhật
					</a>
				</div>
			</Modal.Body>
		</Modal>
	);
};

export const VerifyLicense = ({ show, onHide, openNotifLicense }) => {
	return (
		<Modal show={show} onHide={onHide} dialogClassName="modal-s modal-dialog modal-confirm">
			<Modal.Header closeButton={true} closeLabel={""}>
				<div className="wrap-svg">
					<Fail />
				</div>
			</Modal.Header>
			<Modal.Body>
				<div className="modal-confirm-body">
					<p className="font-14">Bạn cần xác thực GPLX để có thể đặt xe.</p>
					<div className="wrap-btn">
						<a className="btn btn-primary btn--m" onClick={openNotifLicense}>
							Đồng ý
						</a>
					</div>
				</div>
			</Modal.Body>
		</Modal>
	);
};

export const LicenseForm = ({ show, onHide, showChangeDriverLicense }) => {
	return (
		<Modal show={show} onHide={onHide} dialogClassName="modal-m modal-fix modal-text has-footer">
			<Modal.Header closeButton={true} closeLabel={""}></Modal.Header>
			<Modal.Body>
				<div className="modal-text-body">
					<img loading="lazy" className="banner-img" src={dl_confirm} />
					<div className="block-content">
						<b>Xin chào Quý khách hàng,</b>
						<p>
							Nhằm tiếp tục nâng cao chất lượng cộng đồng, cũng như bảo vệ quyền lợi của tất cả các thành viên Mioto khi
							có sự cố ngoài ý muốn phát sinh trong quá trình thuê xe, BQL Mioto xin thông báo về việc triển khai tính
							năng Xác thực GPLX. Các bước xác thực được thực hiện online qua app/website Mioto, thời gian thao tác từ 1
							- 2 phút, chúng tôi rất mong bạn vui lòng dành ít thời gian để hoàn tất bước xác thực này (thành viên cần
							xác thực Số điện thoại + GPLX để có thể gửi yêu cầu đặt xe qua Mioto)
						</p>
					</div>
					<div className="block-content">
						<b>Hướng dẫn</b>
						<p>Bấm vào Ảnh đại diện - chọn Tài khoản - Mục GPLX</p>
						<ul className="disc-ul">
							<li>Nhập số GPLX, họ tên và ngày tháng năm sinh</li>
							<li>Tải hình chụp GPLX lên hệ thống và bấm "Cập nhật"</li>
						</ul>
					</div>
					<div className="block-bg-nd">
						<div className="block-content">
							<b>Ghi chú</b>
							<p>Chỉ yêu cầu xác thực GPLX cho lần đặt xe đầu tiên</p>
							<p>Chỉ có chủ xe có thể nhìn thấy thông tin GPLX khi bạn đang thuê xe</p>
							<p>Thông tin được bảo mật tuyệt đối bởi Mioto</p>
						</div>
					</div>
					<p>
						Rất mong nhận được sự hợp tác từ bạn, vui lòng liên hệ Mioto qua Mioto Fanpage hoặc hotline 19009217 (7AM -
						10PM) nếu bạn cần hỗ trợ
					</p>
					<p>Xin chân thành cám ơn </p>
					<strong>Mioto Team</strong>
				</div>
			</Modal.Body>
			<Modal.Footer>
				<div className="wrap-btn">
					<a className="btn btn--m btn-primary" onClick={showChangeDriverLicense}>
						Xác thực ngay
					</a>
				</div>
			</Modal.Footer>
		</Modal>
	);
};
